import React from 'react';
import cn from 'classnames';

import { XMark } from '@lt/components/icons-react/rebrand';

import styles from './closeButton.module.css';

type Props = {
  className?: string;
  onClick?(): void;
  width?: number;
  height?: number;
};

export const CloseButton = ({
  className,
  width = 32,
  height = 32,
  onClick,
}: Props) => (
  <button
    className={cn(styles.container, className)}
    style={{ width, height }}
    onClick={onClick}
    type="button"
    data-testid="CLOSE_BUTTON_TEST_ID"
  >
    <XMark />
  </button>
);
